
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 4v24h20V4zm2 2h16v20H8zm10 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-5 4c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 2c2.082 0 3.734 1.57 3.938 3.594-.383.273-.735.304-1.22.25-.628-.07-1.437-.375-2.312-.75-.875-.375-1.816-.82-2.875-.938-.355-.039-.715 0-1.094.063A3.961 3.961 0 0116 14zm-3.156 4.125c.133-.008.281.016.437.031.63.07 1.438.375 2.313.75.875.375 1.816.82 2.875.938.355.039.715 0 1.093-.063A3.961 3.961 0 0116 22c-2.082 0-3.734-1.57-3.938-3.594.258-.183.504-.27.782-.281z"}})])
          )
        }
      }
    